import React from "react";
import PropTypes from "prop-types";
import { BsDownload as BsDownloadIcon } from "react-icons/bs";

import { ButtonLinkStyled } from "../../common/Buttons/Button.Style";

import * as S from "./GeneralConditionsSection.style";

const GeneralConditionsSection = ({ title, generalConditionsList }) => {
  return (
    <S.GeneralConditionsSectionContainer>
      <S.GeneralConditionsSectionContent className="container">
        <S.GeneralConditionsSectionTitle>
          {title}
        </S.GeneralConditionsSectionTitle>

        <S.GeneralConditionsSectionList>
          {Array.isArray(generalConditionsList)
            ? generalConditionsList.map((generalConditionsItem) => (
                <ButtonLinkStyled
                  as="a"
                  key={generalConditionsItem.id}
                  href={generalConditionsItem.href}
                  target="_blank"
                >
                  <BsDownloadIcon size={24} />

                  <span>{generalConditionsItem.label}</span>
                </ButtonLinkStyled>
              ))
            : null}
        </S.GeneralConditionsSectionList>
      </S.GeneralConditionsSectionContent>
    </S.GeneralConditionsSectionContainer>
  );
};

GeneralConditionsSection.propTypes = {
  title: PropTypes.string.isRequired,
  generalConditionsList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      href: PropTypes.string,
    })
  ),
};

GeneralConditionsSection.defaultProps = {
  generalConditionsList: [],
};

export default GeneralConditionsSection;
